
//import * as $ from "jquery";

import DrDocWeb from "./drdocweb.js";
import Store from "./drdocstore.js";


//console.log("Dr.DOC INIT 0");

// --

/*
DrDocConfGet = function (names) {
    return DrDocWeb.Send('GET', '/config', { mode: 'get', names: names });
};
DrDocConfSet = function (names, value) {
    //console.warn('ConfSet "' + names + '" / Value has been set:  ', value);
    return DrDocWeb.Send('GET', '/config', { mode: 'set', names: names, value: value });
};
*/

// --

export default function DrDocConfig(store, isLocal) {
    this._isLocal = isLocal === true;
    this._store = store;
    this._config = this;
    this.Write = true;
    this.readonly = false;
    //console.log("Dr.DOC INIT 2");

    //Store._debug = true;

    // keep alive senden
    if (!this._isLocal) {
        let _this = this;
        setInterval(function () {
            if (Store._debug)
                console.log('CONF keep alive..');
            //_this.get('view/selected-usermanager');
            //_this.subscribeEx = function (name, event, defaultValue, parser);
            //_this.subscribeEx('view/selected-usermanager');
            let ret = _this.getValueInternal('view/selected-usermanager');
            if (ret != undefined)
            {
                ret.catch(function(){
                    DrDocWeb.ModalWarning('Keine Internetverbindung oder Server nicht erreichbar.');
                });
            }
        }, 1000 * 60 * 2);
    }
};
window.DrDocConfig = DrDocConfig;

DrDocConfig.prototype.initEx = function (name, event, defaultValue, parser) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.subscribeEx: Instance not found!', this);
    }

    return thisInstance.subscribeEx(name, event, defaultValue, parser);
};

// Subscriber um die geänderten Werte zu speichern
DrDocConfig.prototype.initAutoSaveInternal = function (thisInstance, name, isInitMode) {
    if (thisInstance.has(name)) {
        if (Store._debug)
            console.log('DrDocConfig.initAutoSaveInternal: wurde bereits initialisiert!', name);
    }
    else {
        if (Store._debug)
            console.log('DrDocConfig.initAutoSaveInternal: wird jetzt initialisiert.. ', name);

        // Veränderung der Werte abspeichern
        thisInstance._store.subscribe(name, function (valueNew, valueOld) {
            //var isInitMode = thisInstance._store.has(name) === false;
            //if (Store._debug === true)
            //console.log('subscribeEx -> initEx -> subscribe: ', name, '  isInitMode: ', isInitMode);

            if (thisInstance.readonly)
                return;

            // "initEx" für via "set" mit Signal diesen Subscriber erneut aus,
            // die Daten sollen aber nicht gesetzt/gesendet werden
            if (isInitMode) {
                if (Store._debug)
                    console.log('CONF Value has changed (INIT):', name, valueNew);
                isInitMode = false;
            }
            else {
                thisInstance.setValueInternal(name, valueNew);
            }
        });

        if (Store._debug)
            console.log('DrDocConfig.initAutoSaveInternal: state: ', thisInstance.has(name), ' / isInitMode: ', isInitMode);
    }
    return isInitMode;
};


DrDocConfig.prototype.setValueInternal = function (name, valueNew) {
    if (Store._debug)
        console.log('CONF Value has changed:', name, valueNew);
    if (this.Write === true) {
        if (this._isLocal) {
            if (window.localStorage !== undefined)
                window.localStorage.setItem(name, valueNew);
            else
                DrDocWeb.SetCookie(name, valueNew, 365);
        }
        else
            DrDocWeb.Send('GET', '/config', { mode: 'set', names: name, value: valueNew });
    }
};

DrDocConfig.prototype.getValueInternal = function (name, defaultValue) {
    // gespeicherten Wert zu Initialisierung abrufen
    if (this._isLocal) {
        if (window.localStorage !== undefined) {
            let valRet = window.localStorage.getItem(name);
            if (valRet !== undefined && valRet !== null)
                return valRet;
            else
                return defaultValue;
        }
        else {
            if (Store._debug)
                console.log('CONF Value wurde aus Cookie geladen:', name, ' == ', DrDocWeb.GetCookie(name, defaultValue, 365), '  / [DEFAULT]: ', defaultValue);
            return DrDocWeb.GetCookie(name, defaultValue, 365);
        }
    }
    else {
        // Wer vom Server laden und initialisieren
        return DrDocWeb.Send('GET', '/config', { mode: 'get', names: name }).then(function (val) {
            if (Store._debug)
                console.log('CONF Value wurde vom Server geladen:', name, val);
            return val != undefined && val != null ? val : defaultValue;
        });
    }
};

// Config Variable initialisieren
DrDocConfig.prototype.subscribeEx = function (name, event, defaultValue, parser) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.subscribeEx: Instance not found!', this);
    }

    // Subscribe zuvor aufrufen, damit der Rückgabewert auch das Event feuert
    if (event !== undefined && event !== null)
        thisInstance._store.subscribe(name, event);

    thisInstance._store.initEx(name, function () {
        //if (Store._debug === true)
        //console.log('subscribeEx -> initEx: ', name);

        if (Store._debug)
            console.log('CONF wurde noch nicht initialisiert:', name, ' / default: ', defaultValue)
        // Wert wurde noch nicht geladen

        // Subscribe for Value Changes
        var isNewValue = thisInstance.initAutoSaveInternal(thisInstance, name, true);

        // Default-Value zurückgeben für die Initialisierung
        // gespeicherten Wert zu Initialisierung abrufen
        return thisInstance.getValueInternal(name, defaultValue);
    }, parser);

    //if (!isNewValue)
    //    thisInstance._store.subscribe(name, event);
};
DrDocConfig.prototype.subscribe = function (name, event, defaultValue) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.subscribe: Instance not found!', this);
    }

    return thisInstance.subscribeEx(name, event, defaultValue, Store.Parse);
};
DrDocConfig.prototype.subscribeInt = function (name, event, defaultValue) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.subscribeInt: Instance not found!', this);
    }

    return thisInstance.subscribeEx(name, event, Store.ParseInt(defaultValue), Store.ParseInt);
};
DrDocConfig.prototype.subscribeBool = function (name, event, defaultValue) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.subscribeBool: Instance not found!', this);
    }

    return thisInstance.subscribeEx(name, event, Store.ParseBool(defaultValue), Store.ParseBool);
};

//set: this._store.set.bind(this._store),
//setInt: this._store.setInt.bind(this._store),
//setBool: this._store.setBool.bind(this._store),

DrDocConfig.prototype.set = function (name, value, signal) {
    var thisInstance = this;
    /*if (!thisInstance.has(name) && signal)
    {
        // initialisieren, wenn noch nicht geschehen
        console.log('DrDocConfig.set: wurde noch nicht initialisiert: ', name);
        //thisInstance.subscribe(name, null, value);
    }*/
    thisInstance.initAutoSaveInternal(thisInstance, name, false);
    //this._config.subscribe(name, undefined);
    return this._store.set(name, value, signal);
};

DrDocConfig.prototype.get = function (name, defaultValue) {
    //this._config.subscribe(name, undefined);
    return this._store.get(name, defaultValue);
};

DrDocConfig.prototype.has = function (name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.has: Instance not found!', this);
    }
    return thisInstance._store.has(name);
};

DrDocConfig.prototype.update = function (name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.update: Instance not found!', this);
    }
    return thisInstance._store.update(name);
};

DrDocConfig.prototype.remove = function (name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.remove: Instance not found!', this);
    }
    return thisInstance._store.remove(name);
};

DrDocConfig.prototype.clear = function () {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.clear: Instance not found!', this);
    }
    return thisInstance._store.clear();
};

DrDocConfig.prototype.unsubscribe = function (name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.unsubscribe: Instance not found!', this);
    }
    return thisInstance._store.unsubscribe(name);
};

/*
function BindConfigValue(elem, attrName)
{
    let confName = elem.getAttribute(attrName);
    if (confName == undefined || confName == null || confName == '')
        return;
    //console.log('Conf: ' + confName, elem);
    
    $(elem).on('change', function (newValue, oldValue)
    {
        console.log('Conf: ' + confName, ' | onchange | ', newValue, oldValue);
        DrDoc.configUser.set(confName, elem.value);
    });
 
    DrDoc.configUser.subscribe(confName, function(value) {
        if (value == undefined || value == null)
        {
            elem.value = '';
            return;
        }
        elem.value = value;
        console.log('Conf: ' + confName, ' | new value: ', value);
    });
};
    document.querySelectorAll('select['+attrName+']').forEach(BindConfigValue);
    document.querySelectorAll('input['+attrName+'][type="text"]').forEach(BindConfigValue);
    document.querySelectorAll('input['+attrName+'][type="checkbox"]').forEach(BindConfigCheck);
    document.querySelectorAll('input['+attrName+'][type="number"]').forEach(BindConfigInt);
    document.querySelectorAll('span['+attrName+']').forEach(BindConfigHtml);
*/

// bind-conf-user
// bind-conf-dev="config/view/name"
// bind-conf-dev-value="A"
// bind-conf-dev-default="Default Value"
DrDocConfig.prototype.BindConfig = function (elem, attrName) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) {
        console.warn('DrDocConfig.prototype.BindConfig: Instance not found!', this);
    }
    //thisInstance = DrDocConfig.prototype;

    if (elem._bindConf === true)
        return;
    elem._bindConf = true;

    attrName = DrDocWeb.IsNullOrEmpty(attrName) ? 'bind-conf' : attrName;

    let confName = elem.getAttribute(attrName);
    if (confName == undefined || confName == null || confName == '') {
        console.warn('Biund Conf: empty confName', attrName, elem);
        return;
    }

    let tagName = elem.tagName.toLowerCase();
    let typeName = elem.getAttribute('type') == undefined ? '' : elem.getAttribute('type').toLowerCase();
    let bsToggleName = elem.getAttribute('data-bs-toggle') == undefined ? '' : elem.getAttribute('data-bs-toggle').toLowerCase();
    let defaultValue = elem.getAttribute(attrName + '-default') == undefined ? '' : elem.getAttribute(attrName + '-default');
    let optionValue = elem.getAttribute(attrName + '-value') == undefined ? '' : elem.getAttribute(attrName + '-value');
    let selectValue = elem.getAttribute(attrName + '-select') == undefined ? '' : elem.getAttribute(attrName + '-select');

    //if (defaultValue)
    //console.log('CONF ' , confName, ' = ', defaultValue, ' / tag: ', tagName, ' / bsToggleName: ', bsToggleName);

    function setElemValue(value, oldValue) {
        //console.log('CONF Bind Subsribe fired', confName, '  == ', value, elem);
        switch (tagName) {
            case 'select':
            case 'input':
                switch (typeName) {
                    case 'checkbox':
                        elem.checked = Store.ParseBool(value); // value == undefined || value == null ? false : value;
                        break;

                    case 'radio':
                        var radioOptionElems = document.querySelectorAll('input[type="radio"][name="' + DrDocWeb.SelectorAttributeEncode(elem.getAttribute('name')) + '"]');
                        if (radioOptionElems != null) {
                            //var radioOptionElems2 = document.getElementsByName(elem.getAttribute('name'));
                            //console.log('CONF set elem from conf', value, radioOptionElems, radioOptionElems2);
                            for (var i = 0; i < radioOptionElems.length; i++) {
                                if (radioOptionElems[i].value == value)
                                    radioOptionElems[i].checked = true;
                            }
                        }
                        break;

                    case 'number':
                    case 'text':
                    default:
                        elem.value = value;
                        break;
                }
                break;

            case 'textarea':
                elem.value = value;
                break;

            case 'li':
            case 'button':
            case 'a':
                //console.log('CONF toggle tab: ', confName, ' = ', value, ' | ', optionValue, ' | ', value == optionValue);
                if (value == optionValue) {
                    switch (bsToggleName) {
                        case 'dropdown':
                            DrDocWeb.BS_DropdownShow(elem);
                            break;

                        case 'collapse':
                            DrDocWeb.BS_CollapseShow(elem);
                            break;

                        default:
                        case 'tab':
                            DrDocWeb.BS_TabShow(elem);
                            break;
                    }
                }
                /*    break;

                    default:
                        console.warn('CONF Bad conf attr tab', elem);
                        break;
                //}*/
                break;

            default:
                elem.innerHTML = value; // value == undefined || value == null ? '' : value;
                break;
        }
    };

    // Default Value aus dem ersten verfügbaren Element wählen
    if (DrDocWeb.IsNullOrEmpty(defaultValue)) {
        let selectValueNum = DrDocWeb.ParseInt(selectValue);
        // suche nach [bind-conf-dev=confName][bind-conf-dev-value=".."] oder [bind-conf-dev=confName]>[bind-conf-dev-value=".."]
        let elemDefault = document.querySelector(`[${attrName}="${DrDocWeb.SelectorAttributeEncode(confName)}"][${DrDocWeb.SelectorAttributeEncode(attrName)}-value], [${DrDocWeb.SelectorAttributeEncode(attrName)}="${DrDocWeb.SelectorAttributeEncode(confName)}"]>[${DrDocWeb.SelectorAttributeEncode(attrName)}-value]`);
        if (elemDefault != undefined && elemDefault != null) // && elemDefault.length > 0)
        {
            defaultValue = elemDefault.getAttribute(attrName + '-value');
            if (defaultValue == undefined)
                defaultValue = '';
            if (!DrDocWeb.IsNullOrEmpty(defaultValue) && !DrDocWeb.IsNullOrEmpty(bsToggleName))
            {
                //console.log('Dr.DOC Config: ', 'Name: ', confName, ' / Select-Num: ', selectValueNum, ' / ', ' => ', defaultValue);
                setElemValue(defaultValue);
            }
        }
    }

    // Subscriber einrichten
    // Auf neue Werte warten (listen)
    switch (tagName) {
        case 'select':
        case 'input':
            switch (typeName) {
                case 'number':
                    thisInstance.subscribeInt(confName, setElemValue, defaultValue);
                    break;

                case 'checkbox':
                    thisInstance.subscribeBool(confName, setElemValue, defaultValue);
                    break;

                case 'radio':
                case 'text':
                default:
                    thisInstance.subscribe(confName, setElemValue, defaultValue);
                    break;
            }
            break;

        case 'textarea':
            thisInstance.subscribe(confName, setElemValue, defaultValue);
            break;

        case 'li':
        case 'button':
        case 'a':
            //switch (bsToggleName) {
            //    case 'tab':
            //DrDocWeb.BS_TabShow(elem);
            thisInstance.subscribe(confName, setElemValue, defaultValue);
            //        break;
            //}
            break;

        default:
            thisInstance.subscribe(confName, setElemValue, defaultValue);
            break;
    }

    //thisInstance.update(confName);
    if (thisInstance.has(confName))
        setElemValue(thisInstance.get(confName));

    // Über neue Werte benachrichtigen
    // bei Änderung des Werts
    elem.addEventListener('change', function (newValue, oldValue) {
        if (Store._debug)
            console.log('Conf onChange: ' + confName, ' | onchange: ', oldValue, ' => ', newValue.data, ' / ', elem.value, elem);
        switch (tagName) {
            case 'select':
            case 'input':
                switch (typeName) {
                    case 'checkbox':
                        thisInstance.set(confName, elem.checked);
                        break;

                    case 'radio':
                        var radioOptionElems = document.querySelectorAll('input[type="radio"][name="' + DrDocWeb.SelectorAttributeEncode(elem.getAttribute('name')) + '"]');
                        if (radioOptionElems != null) {
                            //var radioOptionElems2 = document.getElementsByName(elem.getAttribute('name'));
                            //console.log('CONF set conf from elem', newValue, radioOptionElems, radioOptionElems2);
                            for (var i = 0; i < radioOptionElems.length; i++) {
                                if (radioOptionElems[i].checked) {
                                    thisInstance.set(confName, radioOptionElems[i].value);
                                    break;
                                }
                            }
                        }
                        break;

                    case 'number':
                    case 'text':
                    default:
                        thisInstance.set(confName, elem.value);
                        break;
                }
                break;

            case 'textarea':
                thisInstance.set(confName, elem.value.replaceAll("\r", "").replaceAll("\n", "\r\n"));
                //thisInstance.set(confName, elem.innerHTML);
                break;

            case 'button':
            case 'li':
            case 'a':
                break;

            default:
                console.warn('Conf onChange: Unknown Tag Name: ', tagName, ' | ', confName);
                break;
        }
    });

    // Über neue Werte benachrichtigen
    // bei Click
    switch (tagName) {
        case 'li':
        case 'button':
        case 'a':
            //switch (bsToggleName) {
            //    case 'tab':
            elem.addEventListener('click', function (x) {
                //console.log('CONF click ', confName, ' = ', optionValue);
                //DrDocWeb.BS_TabShow(x.target);
                thisInstance.set(confName, optionValue);
            });
            //    break;
            //}
            break;
    }

};






